import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import QrPrintSheet from '../components/QrPrintSheet.jsx';
import { api } from '../services/api.js';

const SHORT = import.meta.env.VITE_SHORT_URL ?? 'https://e.ezbounty.com';

/**
 * Item QR print page. Fetches the item and renders the shared print sheet
 * with the item's short URL, name, and bounty.
 */
export default function PrintQR() {
  const { itemId } = useParams();
  const [item, setItem] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.getItem(itemId).then(setItem).catch((e) => setErr(e.message));
  }, [itemId]);

  if (err) return <div className="alert error">{err}</div>;
  if (!item) return <div className="muted center loading-block">Loading…</div>;

  const url = `${SHORT}/I/${item.itemId}`;
  const bountyText = typeof item.bountyCents === 'number'
    ? `$${(item.bountyCents / 100).toFixed(0)}`
    : '';

  return (
    <div className="container-narrow page">
      <div className="print-controls">
        <Link to={`/items/${item.itemId}`} className="muted tiny">← Back to item</Link>
        <h2 className="mt-12 mb-20">Print QR labels</h2>
      </div>
      <QrPrintSheet
        url={url}
        defaultText="Cash reward!"
        name={item.name}
        bountyText={bountyText || undefined}
        filenameBase={`ezbounty-${item.itemId}`}
      />
    </div>
  );
}
